import { cn } from "@/lib/utils";

export const CrowdLogo = ({ collapsed = false, className }) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {/* Grid Icon - Crowd SA style */}
      <div className="flex flex-wrap w-6 h-6 gap-0.5">
        <div className="w-2.5 h-2.5 rounded-sm bg-[#00A7E1]" />
        <div className="w-2.5 h-2.5 rounded-sm bg-[#00A7E1]" />
        <div className="w-2.5 h-2.5 rounded-sm bg-[#00A7E1]" />
        <div className="w-2.5 h-2.5 rounded-sm bg-[#00A7E1]" />
      </div>
      {!collapsed && (
        <span className="font-bold text-lg tracking-tight heading-font">
          <span className="text-inherit">CROWD</span>
          <span className="text-[#00A7E1]">SA</span>
        </span>
      )}
    </div>
  );
};

export const CrowdLogoFull = ({ className }) => {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      {/* Grid Icon - Larger version */}
      <div className="flex flex-wrap w-8 h-8 gap-0.5">
        <div className="w-3.5 h-3.5 rounded-sm bg-[#00A7E1]" />
        <div className="w-3.5 h-3.5 rounded-sm bg-[#00A7E1]" />
        <div className="w-3.5 h-3.5 rounded-sm bg-[#00A7E1]" />
        <div className="w-3.5 h-3.5 rounded-sm bg-[#00A7E1]" />
      </div>
      <span className="font-bold text-2xl tracking-tight heading-font">
        <span className="text-inherit">CROWD</span>
        <span className="text-[#00A7E1]">SA</span>
      </span>
    </div>
  );
};
